// eslint-disable-next-line
// @ts-ignore
import { v4 as uuidv4 } from "uuid";

export class Guid {
  static get Empty(): string {
    return "00000000-0000-0000-0000-000000000000";
  }

  static newGuid(): string {
    return uuidv4();
  }
}
